import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  endProvisioningPulling,
  startProvisioningCompletion
} from "../projects.slice";

/**
 * Coordinates the transition from provisioning state to loaded state.
 *
 * This thunk ensures that when a project finishes provisioning, we:
 * 1. First mark the org as "completing provisioning" (prevents flash of empty state)
 * 2. Then clear the provisioning project
 *
 * The caller is responsible for:
 * - Calling load() to fetch the updated project list
 * - Dispatching clearProvisioningCompletion after load completes
 */
export const completeProvisioning = createAsyncThunk<
  void,
  { organizationId: string }
>("app/organization/projects/complete_provisioning", (args, { dispatch }) => {
  const { organizationId } = args;

  // Mark as completing first - this prevents flash of "no projects" view
  dispatch(startProvisioningCompletion({ organizationId }));

  // Then clear the provisioning project
  dispatch(endProvisioningPulling({ organizationId }));
});
